module.exports = __webpack_public_path__ + "img/h5_game_detail_gamma3_express.b3729a6a.jpg";